import React, { useState, Fragment, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

// Material-UI Core
import { makeStyles } from "@material-ui/core/styles";
import Fab from "@material-ui/core/Fab";
import Box from "@material-ui/core/Box";
import Tooltip from "@material-ui/core/Tooltip";

// Material-UI Icon
import FolderIcon from "@material-ui/icons/Folder";
import StorageIcon from "@material-ui/icons/Storage";

// Custom Component
import AttachmentChip from "../../Chip/AttachmentChip";

// Custom Style
import { circulationFileZoneContentStyle } from "../../../styles/jss/components/circulation/circulationFileZoneContentStyle";

// Fetch Data
import { fileDownload } from "../../../dataSource/fileManager";

const useStyles = makeStyles((theme) => circulationFileZoneContentStyle(theme));

const RFIFileZoneContent = (props) => {
  const store = require("store");
  const dispatch = useDispatch();
  const userCategoryCode = store.get("user_category_code") || "";
  const isInternal = userCategoryCode === "SANFIELD";

  const propertySeqRedux = useSelector((state) => state.propertySeqRedux);
  const classes = useStyles();
  const {
    title,
    fileType,
    response_seq,
    submissionValue,
    setSubmissionValue,
    presetDraftResponseFiles,
    open,
    fileRemoveAction,
    viewFileAction,
    openFileManagerDialog,
  } = props;

  // Redux Data
  const documentSubmissionCreateValueRedux = useSelector(
    (state) => state.documentSubmissionCreateValueRedux
  );
  const submissionRFIResponseRedux = useSelector(
    (state) => state.submissionRFIResponseRedux
  );
  const submissionRFIDetailRedux = useSelector(
    (state) => state.submissionRFIDetailRedux
  );
  const fileUploadingPropertyRedux = useSelector(
    (state) => state.fileUploadingPropertyRedux
  );
  const [submissionCreateProperty, setSubmissionCreateProperty] =
    useState(null);

  const downloadFileAction = (fileCat, fileSeq) => {
    fileDownload(fileCat, fileSeq).then((res) => {
      console.log(
        "*****************************************************************************"
      );
      console.log("System Module: Document Submission");
      console.log("Message: File download successful.");
      console.log(
        "*****************************************************************************"
      );
    });
  };

  useEffect(() => {
    setSubmissionCreateProperty(documentSubmissionCreateValueRedux);
    // console.log(submissionRFIDetailRedux);
  });

  return (
    <Fragment>
      <div className={classes.messageAttachmentArea}>
        {fileUploadingPropertyRedux !== null
          ? fileUploadingPropertyRedux.map((res, index) => {
              return (
                <AttachmentChip
                  key={index}
                  id={index}
                  filename={res.name}
                  fileSize={res.filesize}
                  fileExtension={"other"}
                  uploading={true}
                  viewFileAction={null}
                  downloadFileAction={null}
                  fileRemoveAction={null}
                />
              );
            })
          : ""}
        {submissionRFIDetailRedux !== null &&
        submissionRFIDetailRedux.draftMessages
          ? submissionRFIDetailRedux.draftMessages
              .filter((obj) => obj.response_seq === response_seq)[0]
              .attachments.map((res, index) => {
                return (
                  <AttachmentChip
                    key={index}
                    id={res.file_seq}
                    filename={res.filename}
                    fileSize={res.filesize}
                    fileExtension={res.extension}
                    viewFileAction={() =>
                      viewFileAction("master", res.file_seq)
                    }
                    downloadFileAction={null}
                    fileRemoveAction={() => {
                      fileRemoveAction(res, response_seq);
                    }}
                  />
                );
              })
          : ""}
      </div>

      <Box className={classes.addFileBtnArea}>
        {isInternal && (
          <Tooltip title="Add File From eFiling">
            <Fab
              color="primary"
              size="small"
              aria-label="add_recipient"
              className={classes.addFileBtn}
              onClick={() => {
                openFileManagerDialog(response_seq);
              }}
            >
              <FolderIcon />
            </Fab>
          </Tooltip>
        )}

        <Tooltip title="Add File From Hard Disk">
          <Fab
            color="primary"
            size="small"
            aria-label="add_recipient"
            className={classes.addFileBtn}
            onClick={open}
          >
            <StorageIcon />
          </Fab>
        </Tooltip>
      </Box>
    </Fragment>
  );
};

export default RFIFileZoneContent;
